module.exports = __webpack_public_path__ + "static/img/成分均匀.165b3e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/metallurgy/成分均匀.jpg
// module id = lMrt
// module chunks = 1